import * as _ from "lodash-es";
import React, { Component } from "react";
import PropTypes from "prop-types";
import ICreatePickListDTO from "../../../models/DTO/ICreatePickListDTO";
import IErrorDTO from "../../../models/DTO/IErrorDTO";
import IGetOrdersTypeaheadDTO from "../../../models/DTO/IGetOrdersTypeaheadDTO";
import IOnCreatePickListDTO from "../../../models/DTO/IOnCreatePickListDTO";
import IOnGetOrdersTypeaheadDTO from "../../../models/DTO/IOnGetOrdersTypeaheadDTO";
import EndpointsEnum from "../../../models/EndpointsEnum";
import ICatalog_Item from "../../../models/ICatalog_Item";
import IOrder from "../../../models/IOrder";
import IPick_List from "../../../models/IPick_List";
import ISupplierModel from "../../../models/ISupplierModel";
import IUserUI from "../../../models/IUserUI";
import IVendorModel from "../../../models/IVendorModel";
import OwButton from "../../shared/OwButton/OwButton";
import OwLabel from "../../shared/OwLabel/OwLabel";
import OwTitle from "../../shared/OwTitle/OwTitle";
import Typeahead from "../../shared/Typeahead/Typeahead";
import "./PickListSidebar.scss";
import { Socket } from "socket.io-client";

type Props = {
    cancel: () => void;
    userModel: IUserUI;
    supplierModel: ISupplierModel;
    socket: Socket;
    pickList?: IPick_List;
    notifyFn: (data: IErrorDTO | null, _notification?: any, isFormatted?: boolean) => void;
};

type State = {
    availableOrders: IOrder[];
    clearOrdersTypeahead: boolean;
    selectedOrders: IOrder[];
    has_order_ship_to: boolean;
    isOrderSearchDisabled: boolean;
    restrictedView: boolean;
    saveActive: boolean;
};

class PickListSidebar extends Component<Props, State> {
    readonly state: State = {
        availableOrders: [],
        selectedOrders: [],
        clearOrdersTypeahead: false,
        has_order_ship_to: false,
        isOrderSearchDisabled: false,
        restrictedView: false,
        saveActive: false,
    };

    componentDidMount(): void {
        this.props.socket.on(EndpointsEnum.OrderOnGetOrdersTypeahead, this.onGetOrdersTypeahead);
        this.props.socket.on(EndpointsEnum.OrderOnCreatePickList, this.onCreatePickList);
    }

    componentWillUnmount(): void {
        this.props.socket.on(EndpointsEnum.OrderOnGetOrdersTypeahead, this.onGetOrdersTypeahead);
        this.props.socket.on(EndpointsEnum.OrderOnCreatePickList, this.onCreatePickList);
    }

    cancel = () => {
        this.props.cancel();
    };

    clearTypeaheadCallback = (stateName: any) => {
        const state: any = {
            [stateName]: false,
        };

        this.setState(state);
    };

    selectedOrder = (order: IOrder) => {
        const state: any = {
            availableOrders: null,
            selectedOrders: [order, ...this.state.selectedOrders],
        };

        this.setState(
            (prevState: any, props: any) => state,
            () => {
                if (this.state.selectedOrders && this.state.selectedOrders.length === 1) {
                    if (!_.isNil(this.state.selectedOrders[0].ship_to_id)) {
                        this.setState({ has_order_ship_to: true });
                    }
                }
            }
        );
    };

    findOrdersByName = (typeahead: string) => {
        const payload: IGetOrdersTypeaheadDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            queryString: `order=${typeahead}`,
            allowQuotes: false,
            allowTemplates: false,
        };

        this.props.socket.emit(EndpointsEnum.OrderGetOrdersTypeahead, payload);
    };

    onGetOrdersTypeahead = (data: IOnGetOrdersTypeaheadDTO) => {
        this.setState({
            availableOrders: data.orders,
        });
    };

    removeOrderFromPickList = (e: any, orderToRemove: IOrder, orderToRemoveIndex: number) => {
        const orders = _.filter(this.state.selectedOrders, (order, index) => {
            return orderToRemoveIndex !== index;
        });

        this.setState(
            (prevState: any, props: any) =>
                ({
                    availableOrders: null,
                    selectedOrders: orders,
                }) as any
        );
    };

    formatSelectedOrders = () => {
        const orders = this.state.selectedOrders;

        if (_.isNil(orders) || !orders.length) {
            return;
        }

        return orders.map((order, index) => {
            return (
                <div className="col-6" key={index}>
                    <span
                        className="pointer"
                        onClick={(e) => {
                            this.removeOrderFromPickList(e, order, index);
                        }}>
                        <i className="fas fa-times text-danger" />
                    </span>{" "}
                    {order.name}
                </div>
            );
        });
    };

    save = () => {
        this.createPickList();
    };

    createPickList = () => {
        const payload: ICreatePickListDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            orderGuids: this.state.selectedOrders.map((order) => {
                return order.guid;
            }),
        };

        this.props.socket.emit(EndpointsEnum.OrderCreatePickList, payload);

        this.setState({
            saveActive: true,
        });
    };

    onCreatePickList = (data: IOnCreatePickListDTO) => {
        this.setState(
            {
                saveActive: false,
            },
            () => {
                this.props.cancel();
            }
        );
    };

    render() {
        const selectedOrderIds = this.formatSelectedOrders();

        return (
            <div className="PickListSidebar p-2">
                <div className={"d-flex flex-column pt-2 h-7r "} style={{ overflow: "hidden" }}>
                    <div className="text-end">
                        <button className="btn btn-danger btn-sm" onClick={this.cancel}>
                            <i className="far fa-times" />
                        </button>
                    </div>
                    <div className={"d-flex align-items-center"}>
                        <OwTitle className={"me-auto"} leftIconName={"fad fa-hand-holding-box"} title={"pick_list"} />
                    </div>
                    <hr />
                </div>

                <div className={""}>
                    <div className={"d-flex align-items-center v-align-center"}>
                        <OwTitle title={"order_ids"} tag={"h5"} className={"d-inline-flex"} />
                        <OwLabel
                            title={"add_one_order_req"}
                            className={
                                "ms-2 mb-0 text-small text-danger " + (this.state.selectedOrders.length ? "d-none" : "d-inline-flex")
                            }
                        />
                    </div>

                    <Typeahead
                        wrapperClassName="mb-2 me-sm-2"
                        className=""
                        typeaheadItems={this.state.availableOrders}
                        clearTypeahead={this.state.clearOrdersTypeahead}
                        clearTypeaheadCallback={() => {
                            this.clearTypeaheadCallback("clearOrdersTypeahead");
                        }}
                        titleProp="name"
                        subTitleProp=""
                        maxResults={5}
                        confirmAdd={true}
                        placeholder="Search Order No"
                        isSelectableFn={() => {
                            return true;
                        }}
                        selectedItemFn={this.selectedOrder}
                        typeaheadApiFn={this.findOrdersByName}
                        disabled={this.state.isOrderSearchDisabled || this.state.restrictedView}
                    />

                    <div>{selectedOrderIds}</div>
                </div>

                <div>
                    <OwButton
                        title={"save"}
                        fn={this.save}
                        disabled={!this.state.selectedOrders.length}
                        active={this.state.saveActive}
                        disableOnActive={true}
                    />
                </div>
            </div>
        );
    }
}

export default PickListSidebar;
